<template>
    <div v-if="loading" class="pt-3">            
        <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
    </div>        
    <div v-else-if="documents.length" class="table-responsive px-2">
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>Patient</th>
                    <th v-if="showCMSColumn">PAN</th>
                    <th v-if="showCMSColumn">DOS</th>
                    <th>Description</th>
                    <th v-if="showClient">Client</th>
                    <th>Created</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="document in documents" :key="'unsubmitted-documents-report-' + document.id">
                    <td>{{ document.patient_name | truncate(25) }}</td>
                    <td v-if="showCMSColumn">
                        <a :href="document.services_href">{{ document.pan }}</a>
                    </td>
                    <td v-if="showCMSColumn">
                        <a :href="document.services_href">{{ document.dos }}</a>
                    </td>
                    <td :title="document.description">
                        <a :href="document.href" target="_blank">{{ document.description | truncate(50) }}</a>
                    </td>
                    <td v-if="showClient">{{ document.client_name | truncate(25) }}</td>
                    <td>{{ document.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                    <td class="text-right">
                        <a :href="document.claim_href" class="px-1" title="View Claim"><i class="fas fa-folder fa-lg"></i></a>                   
                    </td>
                </tr>
            </tbody>
        </table>       
    </div>    
</template>

<script>
import { DocumentType } from '../../constants.js';

export default {
    props: {
        documentTypeId: Number,
        documents: Array,
        loading: Boolean
    },
    data() {
        return {
            DocumentType: DocumentType
        }
    },
    computed: {
        showClient: function () {
            return [...new Set(this.documents.map(document => document.client_name))].length > 1;
        },
        showCMSColumn: function () {
            return [DocumentType.CMS_1500, DocumentType.CMS_1450].includes(this.documentTypeId);
        }        
    },
    methods: {        

    }   
}
</script>

<style scoped>

</style>